import { isValidBirthDateDdMmYyyy, isValidBirthNumber } from './rules';

export function extractBirthNumberPrefix(taxId: string): string | null {
  const digits = taxId.replaceAll(/\s/g, '').replaceAll('/', '').replaceAll(/\D/g, '');
  if (digits.length < 6) {
    return null;
  }
  return digits.slice(0, 6);
}

export function birthNumberMatchesBirthDate(taxId: string, dateValue: string, gender: string): boolean {
  if (!isValidBirthNumber(taxId)) {
    return true;
  }
  const expected = suggestBirthNumberPrefix(dateValue, gender);
  if (!expected) {
    return true;
  }
  const actual = extractBirthNumberPrefix(taxId);
  return actual === expected;
}

export function suggestBirthNumberPrefix(dateValue: string, gender: string): string | null {
  if (!isValidBirthDateDdMmYyyy(dateValue)) {
    return null;
  }

  const parts = dateValue.trim().split('.');
  const day = Number(parts[0]);
  let month = Number(parts[1]);
  const year = Number(parts[2]);

  if (gender === 'mrs') {
    month += 50;
  }

  const yearPart = String(year % 100).padStart(2, '0');
  const monthPart = String(month).padStart(2, '0');
  const dayPart = String(day).padStart(2, '0');

  return `${yearPart}${monthPart}${dayPart}`;
}
